import React, { useEffect, useState } from "react";
import { List, ListItem, ListItemText, Typography, Paper, Box } from "@mui/material";
import SidePanel from "../../components/SidePanel";
import TopBar from "../../components/TopBar";

interface Client {
  clientId: string;
  clientRole: string;
  ownerName?: string;
  carType?: string;
}
interface Event {
  event: string;
  client: Client;
  error: string;
  connections: string;
}
const WebSocketComponent: React.FC = () => {
  const [connectedClients, setConnectedClients] = useState<Client[]>([]);
  const [disconnectedClients, setDisconnectedClients] = useState<Client[]>([]);
  const [errors, setErrors] = useState<string[]>([]);

  useEffect(() => {
    const API_KEY = process.env.REACT_APP_API_KEY;
    const socketBaseUrl = process.env.REACT_APP_WEB_SOCKET_SERVICE_BASE_URL
    const socket = new WebSocket(
      `${socketBaseUrl}?api_key=${API_KEY}`
    );

    socket.onopen = () => {
      console.log("WebSocket connection opened");
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data) as Event;
      console.log("Message received", data);
      switch (data.event) {
        case "connect":
          console.log("WebSocket connection", data);
          setConnectedClients(JSON.parse(data.connections));
          break;
        case "disconnect":
          console.log("WebSocket connection", data);
          setDisconnectedClients((prevClients) => [...prevClients, data.client]);
          setConnectedClients(JSON.parse(data.connections));
          break;
        case "error":
          setErrors((prevErrors) => [...prevErrors, data.error]);
          setConnectedClients(JSON.parse(data.connections));
          break;
        default:
          break;
      }
    };

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    socket.onclose = () => {
      console.log("WebSocket connection closed");
    };

    return () => {
      socket.close();
    };
  }, []);

  return (
    <Box className="mainContainer">
      <Box className="sidePanelContainer">
        <SidePanel isOpen={true} onClose={() => {}} />
      </Box>
      <Box className="dashboardContainer">
        <TopBar />
        <Box style={{ width: "100%", padding: "20px", marginTop: "5%" }}>
          <Paper elevation={3} style={{ margin: "20px", padding: "20px" }}>
            <Typography variant="h5">Connected Clients</Typography>
            <List>
              {connectedClients.map((client) => (
                <ListItem key={client.clientId}>
                  <ListItemText primary={`ID: ${client.clientId} | Role: ${client.clientRole}`} />
                </ListItem>
              ))}
            </List>
          </Paper>
          <Paper elevation={3} style={{ margin: "20px", padding: "20px" }}>
            <Typography variant="h5">Disconnected Clients</Typography>
            <List>
              {disconnectedClients.map((client) => (
                <ListItem key={client.clientId}>
                  <ListItemText primary={`ID: ${client.clientId} | Role: ${client.clientRole}`} />
                </ListItem>
              ))}
            </List>
          </Paper>

          <Paper elevation={3} style={{ margin: "20px", padding: "20px" }}>
            <Typography variant="h5">Errors</Typography>
            <List>
              {errors.map((error, index) => (
                <ListItem key={index}>
                  <ListItemText primary={`${error}`} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default WebSocketComponent;
